module.exports = __webpack_public_path__ + "img/leaf8.1e29be6f.png";